/*
  SV Options add-on: "Compare thicknesses" button for native Thickness options
  ---------------------------------------------------------------------------
  The main sv-options.js only shows the Compare thicknesses button on options it
  builds itself. Listings whose Thickness is a native Shopify option (like the
  Acrylic Bookmark Blanks) are drawn by renderVariantProxy, which had no button.
  This file adds the button there, gives bookmarks their own notes, and uses a
  colon instead of a dash between each thickness name and its note.

  © Seery-Us Visionz, all rights reserved.
*/
(function () {
  if (!window.customElements) return;

  var BOOKMARK_NOTES = {
    '1/16': 'Sturdier and rigid. Best for rhinestones, epoxy and heavier decorating.',
    '1/32': 'Half as thick, lighter, with a slight flex. Slips easily between pages.'
  };

  function keyOf(label) {
    var l = String(label || '').toLowerCase();
    if (/ultra|1\/32/.test(l)) return '1/32';
    if (/1\/16|\bthin\b/.test(l)) return '1/16';
    if (/1\/8|regular/.test(l)) return '1/8';
    return null;
  }

  customElements.whenDefined('sv-options').then(function () {
    var C = customElements.get('sv-options');
    if (!C || C.prototype.__svThickNative) return;
    var P = C.prototype;
    P.__svThickNative = true;

    // 1) Bookmark-specific notes
    var origRows = P.thicknessRows;
    P.thicknessRows = function (opt) {
      var rows = origRows.call(this, opt) || [];
      if (/bookmark/i.test((this.cfg && this.cfg.productTitle) || '')) {
        rows = rows.map(function (r) {
          var k = keyOf(r.label);
          return k && BOOKMARK_NOTES[k] ? Object.assign({}, r, { note: BOOKMARK_NOTES[k] }) : r;
        });
      }
      return rows;
    };

    // 2) Button next to native Thickness options
    var origProxy = P.renderVariantProxy;
    P.renderVariantProxy = function () {
      var html = origProxy.call(this);
      if (!html || !this.pv) return html;
      var self = this;
      this.pv.forEach(function (g) {
        if (!/thickness/i.test(g.name || '')) return;
        var fake = { values: g.values.map(function (v) { return { label: v }; }) };
        if (!self.thicknessRows(fake).length) return;
        var marker = 'id="' + self.uid + '-var' + g.pos + '-l"';
        var at = html.indexOf(marker);
        if (at < 0) return;
        var close = html.indexOf('</span>', at);
        if (close < 0) return;
        close += '</span>'.length;
        var btn = ' <button type="button" class="sv-thick-btn" data-sv-thick="pv' + g.pos + '">Compare thicknesses</button>';
        html = html.slice(0, close) + btn + html.slice(close);
      });
      return html;
    };

    // 3) Open the popup for native options, and use colons instead of dashes
    var origOpen = P.openThickness;
    P.openThickness = function (optId) {
      var id = String(optId || '');
      if (/^pv\d+$/.test(id)) {
        var pos = parseInt(id.slice(2), 10);
        var g = (this.pv || []).filter(function (x) { return x.pos === pos; })[0];
        if (!g) return;
        var fake = { id: id, label: g.name, values: g.values.map(function (v) { return { label: v }; }) };
        var origFind = this.optById;
        this.optById = function (x) { return x === id ? fake : origFind.call(this, x); };
        try { origOpen.call(this, id); } finally { this.optById = origFind; }
      } else {
        origOpen.call(this, optId);
      }
      var dlg = this.querySelector('dialog.sv-thick');
      if (dlg) {
        dlg.querySelectorAll('.sv-thick__list li').forEach(function (li) {
          li.innerHTML = li.innerHTML.replace(/<\/strong>\s*[–—-]\s*/, '</strong>: ');
        });
        // Same fix inside the side-view drawing labels
        dlg.querySelectorAll('svg text, svg tspan').forEach(function (t) {
          t.childNodes.forEach(function (n) {
            if (n.nodeType === 3 && /\s[–—-]\s/.test(n.nodeValue)) {
              n.nodeValue = n.nodeValue.replace(/\s+[–—-]\s+/g, ': ');
            } else if (n.nodeType === 3 && /^\s*[–—-]\s+/.test(n.nodeValue)) {
              n.nodeValue = n.nodeValue.replace(/^\s*[–—-]\s+/, ': ');
            }
          });
        });
      }
    };

    // Re-render any options already on the page so the button shows up
    document.querySelectorAll('sv-options').forEach(function (el) {
      try { if (typeof el.render === 'function' && el.state) { el.render(); el.refresh && el.refresh(); } } catch (e) {}
    });
  });
})();
